<script setup lang="ts">
import { useSidebarLayout } from './sidebarLayout';
const { collapsed, toggle } = useSidebarLayout();
</script>

<template>
  <button
    class="btn btn-outline-secondary btn-sm me-2"
    type="button"
    @click="toggle"
  >
    <iconify-icon noobserver :icon="collapsed ? 'mdi:menu' : 'mdi:menu-open'" />
  </button>
</template>
